import React from 'react'
import Loader from '../../loaders'
import Map from '../../map'
import { RESOURCES_URL } from '../../../server/connection'
import { getLockers } from '../../../helpers/restHelpers'
import routes from '../../router/routes'

const getResourceUrl = (key) => RESOURCES_URL + 'Resource/get?key=' + key
const availableMarker = getResourceUrl('LockerMarker')

class Component extends React.Component {
    state = {
        ready: false,
        zoom: 12,
        position: { lat: -34.5997376, lng: -58.4515767 },
        lockers: [],
        markerSelectedId: null,
    }

    getMapData = () => {
        const getInfoWindowContent = (locker) => {
            return (
                '<div id="content" style="text-align: center">' +
                '<h3><b>' +
                locker.name +
                '</b></h3>' +
                (!locker.address ? '' : '<p>' + locker.address + '</p>') +
                (!locker.locationDetails.length
                    ? ''
                    : '<p>' + locker.locationDetails + '</p>') +
                (!locker.lockerMessage
                    ? ''
                    : '<div class="Pudo-Locker-message-type-' +
                      locker.lockerMessage.typeName +
                      '">' +
                      locker.lockerMessage.text +
                      '</div>') +
                '</div>'
            )
        }

        var mapData = {
            options: {
                zoom: this.state.zoom,
                center: { lat: this.state.latitude, lng: this.state.longitude },
            },
            markers: [],
        }

        if (this.state.lockers) {
            this.state.lockers.forEach((locker) => {
                mapData.markers.push({
                    options: {
                        markerId: locker.id,
                        icon: availableMarker,
                        position: {
                            lat: locker.latitude,
                            lng: locker.longitude,
                        },
                    },
                    infoWindow: {
                        options: { content: getInfoWindowContent(locker) },
                    },
                })
            })
        }
        return mapData
    }

    componentDidMount() {
        getLockers()
            .then((x) => {
                this.setState({
                    ready: true,
                    ...x,
                })
            })
            .catch((error) => {
                window.showDialog(error, () => {
                    this.props.history.replace(routes.orders.path)
                })
            })
    }

    render() {
        if (!this.state.ready) return <Loader />

        const mapData = this.getMapData()

        return (
            <Map
                style={{ width: '100%', height: '100%' }}
                id="map-locker-map"
                mapData={mapData}
                visible={true}
                handleMarkerOnClick={(x) =>
                    this.setState({ markerSelectedId: x })
                }
                markerSelectedId={this.state.markerSelectedId}
                handleZoomChange={(x) =>
                    x === this.state.zoom ? null : this.setState({ zoom: x })
                }
            />
        )
    }
}

export default Component
